import { render, staticRenderFns } from "./HistoryCollectionTask.vue?vue&type=template&id=df6144f6&scoped=true"
import script from "./HistoryCollectionTask.vue?vue&type=script&lang=js"
export * from "./HistoryCollectionTask.vue?vue&type=script&lang=js"
import style0 from "./HistoryCollectionTask.vue?vue&type=style&index=0&id=df6144f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6144f6",
  null
  
)

export default component.exports